"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Globe, Shield, Truck } from "lucide-react";
export default function CompanyOverview() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="companyoverview" className="bg-background py-16 md:py-24 lg:py-32 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-16 items-center">
          {}
          <div ref={contentRef} className={`transition-all duration-700 ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <h2 className="text-3xl sm:text-4xl font-default font-bold text-foreground mb-6">Industrial Feedstock Operations</h2>

            <p className="text-base sm:text-lg text-foreground/90 font-default leading-relaxed mb-5">Oriental World Corporation Limited is a Hong Kong-based trading company specializing in industrial oils and biofuel feedstocks across the Far East.<br /><div data-ast-id="f:/src/pages/Home/sections/CompanyOverview.tsx|sig:5kwp8p" data-ast-start="1546" data-ast-end="1701" contenteditable="false"><br /></div><div data-ast-id="f:/src/pages/Home/sections/CompanyOverview.tsx|sig:5jvrpj" data-ast-start="1701" data-ast-end="2068" contenteditable="false" spellcheck="false">Our Yuen Long facility supports the handling and coordination of industrial bovine and sheep tallow, used cooking oil (UCO), mixed acid oil (MAO) and plant-based feedstocks for renewable fuel and industrial applications.</div><div data-ast-id="f:/src/pages/Home/sections/CompanyOverview.tsx|sig:56kqct" data-ast-start="2068" data-ast-end="2199"><br /></div><div data-ast-id="f:/src/pages/Home/sections/CompanyOverview.tsx|sig:55l5rh" data-ast-start="2199" data-ast-end="2475">Through regional logistics and export coordination, we work with suppliers, processors, and downstream buyers across Asia, supporting industrial feedstock sourcing and trade operations across key regional markets.</div></p>

            

            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <Globe className="size-6 text-primary flex-shrink-0" />
                <div>
                  <h3 className="font-default font-semibold text-foreground mb-2">
                    Regional Expertise
                  </h3>
                  <p className="text-sm text-foreground/80 font-default">Deep operational knowledge across East Asia, Southeast Asia, and South Asia trade corridors.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Shield className="size-6 text-primary flex-shrink-0" />
                <div>
                  <h3 className="font-default font-semibold text-foreground mb-2">
                    Compliance & Certification
                  </h3>
                  <p className="text-sm text-foreground/80 font-default">ISCC certified operations ensuring sustainable sourcing and regulatory compliance.</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Truck className="size-6 text-primary flex-shrink-0" />
                <div>
                  <h3 className="font-default font-semibold text-foreground mb-2">
                    Logistics Management
                  </h3>
                  <p className="text-sm text-foreground/80 font-default">End-to-end coordination of shipping, port operations, and supply chain logistics.</p>
                </div>
              </div>
            </div>

            <div className="pt-8">
              <Button asChild size="lg" className="rounded-md">
                <Link to="/AboutUsPage">
                  Learn More
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`transition-all duration-700 ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <div className="relative h-96 sm:h-[500px] lg:h-[700px] w-full overflow-hidden rounded-lg shadow-lg">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/factory aerial shot.jpg" alt="Industrial factory and manufacturing operations" className="w-full h-full object-cover" loading="lazy" decoding="async" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}